export default __webpack_public_path__ + "i18n/translation-kn.633e0476.json";